import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import { withApplicationContext } from '../../utils/ApplicationContext';
import _ from '../../utils/LodashImports';
import { ADS_SIZE_CONFIG } from './constants';
import GoogleAdsStyles from './GoogleAds.style';
import { getTargetValues, waitForDigitalDataSiS } from './helpers';

const GoogleAdComponent = ({ appCtx, adsPosition, deviceType, productGcategory }) => {
  const [targetData, setTargetData] = useState();

  const { GET_ARRAY_INFO, ADS_SIZE_DESKTOP, ADS_SIZE_MOBILE, CLASSNAME } = ADS_SIZE_CONFIG[adsPosition];
  const { pdp } = _.get(appCtx, 'siteConfig.configurations.adsConfig', '{}');
  const adsData = pdp ? pdp[GET_ARRAY_INFO] : null;
  const adSizes = deviceType === 'desktop' ? ADS_SIZE_DESKTOP : ADS_SIZE_MOBILE;
  const hasRun = useRef(false);

  useEffect(() => {
    const fetchTargetData = async () => {
      await waitForDigitalDataSiS();
      const data = getTargetValues(appCtx, productGcategory);
      setTargetData(data);
    };
    fetchTargetData();
  }, [appCtx, productGcategory]);

  useEffect(() => {
    if (hasRun.current || !pdp || !adsData || !targetData) return;
    hasRun.current = true;

    if (!window.googletag?.cmd) {
      window.googletag = { cmd: [] };
    }
    window.googletag.cmd.push(() => {
      const slotId = adsData?.slot;
      const path = adsData?.folder;
      const pubads = window.googletag.pubads();

      if (window.googletag?.pubads?.().getSlots) {
        const existingSlots = window.googletag.pubads().getSlots();
        const existingSlot = existingSlots.find((slot) => slot.getSlotElementId() === slotId);
        if (existingSlot) {
          return;
        }
      }
      const slot = window.googletag.defineSlot(path, adSizes, slotId);
      window.googletag.pubads().enableLazyLoad();

      if (!slot) {
        return;
      }

      slot?.addService(window.googletag.pubads());

      if (targetData) {
        if (targetData?.emailHash) {
          pubads.setPublisherProvidedId(targetData.emailHash);
        }

        Object.entries(targetData).forEach(([key, value]) => {
          if (value) {
            pubads.setTargeting(key, value);
          }
        });
      }

      pubads.enableSingleRequest();
      pubads.collapseEmptyDivs(true);
      window.googletag.enableServices();
      window.googletag.display(slotId);
    });
  }, [adsData, adSizes, targetData, pdp]);

  if (!pdp || !adsData) {
    return null;
  }
  return (
    <>
      <style jsx>{GoogleAdsStyles}</style>
      <div id={adsData?.slot} className={`ad-component-${CLASSNAME}`} />
    </>
  );
};

GoogleAdComponent.propTypes = {
  adsPosition: PropTypes.string.isRequired,
  appCtx: PropTypes.object.isRequired,
  deviceType: PropTypes.string.isRequired,
  productGcategory: PropTypes.string.isRequired,
};

export { GoogleAdComponent };
export default withApplicationContext(GoogleAdComponent);
